<template>
  <div class="table-container">
    <h3 @click="toggleTable" class="table-title">
      Hunting Draw Points
      
      <span class="toggle-icon" >
        <i :class="[tableIsCollapsed ? 'mdi mdi-chevron-up float-right' : 'mdi mdi-chevron-down float-right']"></i>
      </span>
    </h3>

    <table v-if="this.tableIsCollapsed" class="table">
      <thead>
        <tr>
          <th>Species</th>
          <th>Next Eligible Year</th>
          <th>Points</th>
        </tr>
      </thead>
      <tbody>
        <tr 
          v-for="(item, index) in data.filter(item => !item.ineligibleReason)" 
          :key="item.id"
          @click="handleRowClick(item)"
          class="clickable-row"
        >
          <td>{{ item.species }}</td>
          <td>{{ item.nextEligible }}</td>
          <td>{{ item.points }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "DrawPointsTable",
  props: {
    // Array of objects to display in the table
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return { tableIsCollapsed: true }
  },
  methods: {
    toggleTable() {
      this.tableIsCollapsed = !this.tableIsCollapsed;
    },
    handleRowClick(item) {
      this.$emit('row-click', item);
    }
  }
};
</script>

<style scoped>
.table-container {
  max-width: 800px;
  margin: 20px auto;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.table-title {
  text-align: center;
  margin-bottom: 15px;
  font-weight: bold;
  font-size: 1.5rem;
  color: #333;
  cursor: pointer;
  background-color: lig;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table thead {
  background-color: lightblue;
  color: black;
}

.table th,
.table td {
  text-align: left;
  padding: 10px;
  border: 1px solid #ddd;
}

.table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

.table tbody tr:hover {
  background-color: #e9ecef;
  cursor: pointer;
}

.clickable-row {
  transition: background-color 0.2s ease;
}
</style>
